export { EloClipboardIcon } from './clipboard-icon'
